<nz-modal
  nzVisible="true"
  [nzCancelText]="null"
  (nzOnOk)="onReadNote()"
  nzOkText="{{ 'common.agree' | transloco }}"
  nzTitle="{{ 'common.note' | transloco }}"
  [nzClosable] = "false"
>
  <ng-container *nzModalContent>
    {{"common.contentNote" | transloco}}
  </ng-container>
</nz-modal>
